/* =====================
   Mise à jour de divers éléments en cas de changement de variante nécessitant une nouvelle recherche de documents
   ===================== */
window.refreshProductVariant = async (form, variant) => {
  const revision = (form.__variantRevision || 0) + 1;
  form.__variantRevision = revision;
  form.__variantController?.abort();
  form.__variantController = null;
  form.removeAttribute("data-variant-loading");
  form.querySelector("[data-variant-refresh-error]")?.remove();

  const selectors = ["#inventory-bar", "#product-qty-breaks", "#product-store-availability-wrapper"];
  const blocks = selectors.map((selector) => form.querySelector(selector)).filter(Boolean);
  blocks.forEach((block) => { block.hidden = true; });
  if (!variant || !blocks.length || !form.closest("#product-template") || !form.closest("[data-section-id]")?.dataset.sectionId) return;

  const controller = new AbortController();
  form.__variantController = controller;
  form.setAttribute("data-variant-loading", "true");
  const variantId = String(variant.id);
  const isCurrent = () => form.isConnected && form.__variantRevision === revision &&
    form.querySelector('[name="id"]')?.value === variantId;
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  const sectionId = form.closest("[data-section-id]")?.dataset.sectionId;
  if (!sectionId) return;
  url.searchParams.delete("sections");
  url.searchParams.set("section_id", sectionId);

  try {
    const response = await fetch(url.href, { cache: "no-store", signal: controller.signal });
    if (!response.ok) throw new Error("Variant refresh HTTP error");
    const text = await response.text();
    if (!isCurrent()) return;
    const newDocument = new DOMParser().parseFromString(text, "text/html");
    const newForm = newDocument.querySelector('#product-template .product-content form');
    if (newForm?.querySelector('[name="id"]')?.value !== variantId) {
      throw new Error("Variant refresh does not match selection");
    }
    const replacements = blocks.map((block) => ({
      current: block,
      next: newForm.querySelector(`#${block.id}`),
    }));
    if (replacements.some(({ next }) => !next)) throw new Error("Variant refresh missing fragment");
    if (!isCurrent()) return;
    replacements.forEach(({ current, next }) => current.replaceWith(next));
    initializeInventoryBar();
    initializeQantityBreaks();
  } catch (error) {
    if (!isCurrent() || error.name === "AbortError") return;
    const alert = document.createElement("div");
    alert.setAttribute("data-variant-refresh-error", "");
    alert.setAttribute("role", "status");
    alert.className = "alert alert-warning my-3";
    alert.textContent = window.theme.product.variantRefreshError;
    form.querySelector(".product-variant-selector")?.after(alert);
  } finally {
    if (form.__variantRevision === revision) {
      form.removeAttribute("data-variant-loading");
      form.__variantController = null;
    }
  }
};

window.updateProductOptionAvailability = (form, selectedOptions) => {
  const groups = [...form.querySelectorAll(".product-option-wrapper")];
  groups.forEach((group, index) => {
    group.querySelectorAll('.size-buttons input.product-option').forEach((option) => {
      const available = window.productVariants.some((variant) => variant.available &&
        variant.options[index] === option.value &&
        variant.options.slice(0, index).every((value, previous) => !selectedOptions[previous] || value === selectedOptions[previous]));
      const label = option.nextElementSibling;
      if (label?.tagName === "LABEL") label.classList.toggle("disabled", !available);
    });
  });
};

/* =====================
   Options d'achat (plans de vente/abonnement)
   ===================== */
const initializePurchaseOptions = () => {
  const wrapper = document.querySelector("#purchase-options-product");

  if (!wrapper) return;

  wrapper.querySelectorAll('[name="purchase_option"]').forEach((input) => {
    input.addEventListener("change", () => {
      if (input.id === "purchase-options-one-time") {
        wrapper
          .querySelector("#purchase-delivery-options")
          .setAttribute("hidden", "hidden");
        wrapper.querySelector('[name="selling_plan"]').disabled = true;

        if (input.closest("#product-template")) {
          const url = new URL(window.location);
          url.searchParams.delete("selling_plan");
          window.history.replaceState({}, "", url);
        }
      } else {
        wrapper
          .querySelector("#purchase-delivery-options")
          .removeAttribute("hidden");
        wrapper.querySelector('[name="selling_plan"]').disabled = false;

        if (input.closest("#product-template")) {
          const url = new URL(window.location);
          url.searchParams.set(
            "variant",
            wrapper.closest(".product-content").querySelector('[name="id"]')
              .value
          );
          url.searchParams.set(
            "selling_plan",
            wrapper.querySelector('[name="selling_plan"]').value
          );
          window.history.replaceState({}, "", url);
        }
      }
    });
  });

  const selectDeliverEvery = wrapper.querySelector(
    "#options-select-purchase-delivery"
  );

  if (selectDeliverEvery) {
    selectDeliverEvery.addEventListener("change", () => {
      if (selectDeliverEvery.closest("#product-template")) {
        const url = new URL(window.location);
        url.searchParams.set(
          "selling_plan",
          wrapper.querySelector('[name="selling_plan"]').value
        );
        window.history.replaceState({}, "", url);
      }
    });
  }

  if (wrapper.dataset.subSelectedFirst === "true") {
    wrapper.querySelector("input#purchase-options-subscription").checked = true;
    wrapper
      .querySelector("input#purchase-options-subscription")
      .dispatchEvent(new Event("change"));
  }
};
initializePurchaseOptions();

/* =====================
   Formatage du prix sans décimales
   ===================== */
Shopify.formatMoneyNoDecimals = function(cents) {
  const formatted = Shopify.formatMoney(cents);
  return formatted.replace(/[.,]00(?!\d)/g, '');
};

/* =====================
   Sélecteur d'options de produits - Écouter les événements de changement
   ===================== */
window.announceProductVariant = (form, variant, options) => {
  const status = form.querySelector("[data-variant-status]");
  if (!status) return;
  const priceNode = form.closest(".product-content")?.querySelector(".product-price-final")?.cloneNode(true);
  priceNode?.querySelectorAll(".visually-hidden").forEach((label) => label.remove());
  const price = priceNode?.textContent.replace(/\s+/g, " ").trim();
  const availability = variant ? (variant.available ? status.dataset.available : status.dataset.soldOut) : status.dataset.unavailable;
  status.textContent = [options.join(" / "), variant && price ? `${status.dataset.priceLabel} ${price}` : "", availability].filter(Boolean).join(". ");
};

window.handleProductOptionChange = async (input) => {
  const form = input.closest("form");
  let refresh;
  const groups = [...form.querySelectorAll('.product-option-wrapper')];
  const selectedOptions = groups.map((group) =>
    group.querySelector('input.product-option:checked, select.product-option')?.value || '');
  const selector = form.querySelector('[data-require-option-selection]');
  const incomplete = Boolean(selector && selectedOptions.some((value) => !value));
  const idInput = form.querySelector('[name="id"]');
  if (selector) idInput.disabled = incomplete;
  const title = input.closest('.product-option-wrapper')?.querySelector('.size-buttons-title span, .color-swatches-title span');
  if (title) title.textContent = input.dataset.displayValue || input.value;

  if (incomplete) {
    window.updateProductOptionAvailability(form, selectedOptions);
    const button = form.querySelector('.btn-atc');
    clearTimeout(button?.__cartFeedbackTimer);
    button.disabled = false;
    button.textContent = selector.dataset.selectSize;
    form.querySelectorAll('.product-form-dynamic-buttons').forEach((wrapper) => { wrapper.hidden = true; });
    form.querySelectorAll('.btn-buy').forEach((button) => { button.disabled = true; });
    const url = new URL(window.location.href);
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url);
    const status = selector.querySelector('[data-variant-status]');
    if (status) status.textContent = selector.dataset.selectSize;
    return window.refreshProductVariant(form, null);
  }

  const variantSelected = window.productVariants.find(
    (variant) =>
      JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
  );

  window.updateProductOptionAvailability(form, selectedOptions);
  clearTimeout(form.querySelector(".btn-atc")?.__cartFeedbackTimer);

  const btn = input.closest("form").querySelector(".btn-atc");

  if (variantSelected) {
    input.closest("form").querySelector('[name="id"]').value =
      variantSelected.id;

    if (variantSelected.available) {
      btn.disabled = false;
      btn.innerHTML = window.theme.product.addToCart;
    } else {
      btn.disabled = true;
      btn.innerHTML = window.theme.product.soldOut;
    }

    if (variantSelected.compare_at_price > variantSelected.price) {
      input
        .closest(".product-content")
        .querySelector(".product-price").innerHTML = `
                  <span class="product-price-final me-3">
                      <span class="visually-hidden">
                          ${window.theme.product.priceSale} &nbsp;
                      </span>
                      ${Shopify.formatMoneyNoDecimals(variantSelected.price)}
                  </span>
                  <span class="product-price-compare text-muted">
                      <span class="visually-hidden">
                          ${window.theme.product.priceRegular} &nbsp;
                      </span>
                      <s>
                          ${Shopify.formatMoneyNoDecimals(
                            variantSelected.compare_at_price
                          )}
                      </s>
                  </span>
              `;
    } else {
      input
        .closest(".product-content")
        .querySelector(".product-price").innerHTML = `
                  <span class="product-price-final">
                      ${Shopify.formatMoneyNoDecimals(variantSelected.price)}
                  </span>
              `;
    }
    if (variantSelected.available && variantSelected.compare_at_price) {
      input
        .closest(".product-content")
        .querySelector(".product-price")
        .insertAdjacentHTML(
          "beforeend",
          `
                  <span class="price-badge-sale badge">
                      -${Math.round(
            (1 - variantSelected.price / variantSelected.compare_at_price) * 100
          )}%
                  </span>
              `
        );
    } else if (!variantSelected.available) {
      input
        .closest(".product-content")
        .querySelector(".product-price")
        .insertAdjacentHTML(
          "beforeend",
          `
                  <span class="price-badge-sold-out badge">
                      ${window.theme.product.soldOut}
                  </span>
              `
        );
    }

    const purchaseOptionsWrapper = document.querySelector(
      "#purchase-options-product"
    );

    if (purchaseOptionsWrapper) {
      purchaseOptionsWrapper.querySelector(
        "input#purchase-options-one-time + label [data-price]"
      ).textContent = Shopify.formatMoneyNoDecimals(variantSelected.price);
      purchaseOptionsWrapper.querySelector(
        "input#purchase-options-subscription + label [data-price]"
      ).textContent = Shopify.formatMoneyNoDecimals(
        variantSelected.selling_plan_allocations[0].price
      );
    }

    const skuWrapper = input
      .closest(".product-content")
      .querySelector(".current-variant-sku");

    if (skuWrapper) {
      if (variantSelected.sku?.length) {
        skuWrapper.textContent = variantSelected.sku;
        skuWrapper.removeAttribute("hidden");
      } else {
        skuWrapper.setAttribute("hidden", "hidden");
      }
    }

    if (input.closest("#product-template")) {
      const url = new URL(window.location);
      url.searchParams.set("variant", variantSelected.id);
      window.history.replaceState({}, "", url);
    }

    refresh = window.refreshProductVariant(form, variantSelected);
    const customEvent = new CustomEvent("variantChange.shopiweb.product", {
      detail: variantSelected,
    });
    window.dispatchEvent(customEvent);
  } else {
    btn.disabled = true;
    btn.innerHTML = window.theme.product.unavailable;
    form.querySelector('[name="id"]').value = "";
    const content = form.closest(".product-content");
    const price = content?.querySelector(".product-price");
    if (price) price.textContent = window.theme.product.unavailable;
    content?.querySelector(".current-variant-sku")?.setAttribute("hidden", "hidden");
    if (form.closest("#product-template")) {
      const url = new URL(window.location.href);
      url.searchParams.delete("variant");
      window.history.replaceState({}, "", url);
    }
    refresh = window.refreshProductVariant(form, null);
  }
  form.querySelectorAll(".product-form-dynamic-buttons").forEach((wrapper) => {
    wrapper.hidden = !variantSelected?.available;
  });
  form.querySelectorAll(".btn-buy").forEach((button) => {
    button.disabled = !variantSelected?.available;
  });

  if (input.closest(".color-swatches")) {
    input
      .closest(".product-option-wrapper")
      .querySelector(".color-swatches-title span").textContent = input.dataset.displayValue || input.value;
  }

  if (input.closest(".size-buttons")) {
    input
      .closest(".product-option-wrapper")
      .querySelector(".size-buttons-title span").textContent = input.dataset.displayValue || input.value;
  }
  form.closest(".product-content")?.querySelectorAll("[data-klarna-installments]").forEach((line) => {
    const amounts = JSON.parse(line.dataset.klarnaAmounts);
    const amount = variantSelected && amounts[String(variantSelected.id)];
    line.hidden = !amount || variantSelected.price <= 0;
    line.querySelector("[data-klarna-amount]").textContent = amount || "";
  });
  window.announceProductVariant(form, variantSelected, selectedOptions);
  return refresh;
};

/* =====================
   Galerie de produits
   ===================== */
const initializeProductGallery = () => {
  document
    .querySelectorAll(".product-gallery:not(.init)")
    .forEach((gallery) => {
      gallery.classList.add("init");

      const isProductPageGallery = Boolean(gallery.closest("#product-template"));
      const hasMultipleMedia = gallery.querySelectorAll(".main-splide .splide__slide").length > 1;

      const main = new Splide(gallery.querySelector(".main-splide"), {
        start: Number(gallery.dataset.start),
        drag: hasMultipleMedia,
        rewind: hasMultipleMedia,
        arrows: false,
        rewindByDrag: hasMultipleMedia,
        pagination: false,
        noDrag: "model-viewer",
        mediaQuery: "min",
        breakpoints: {
          0: {
            destroy: false,
            keyboard: isProductPageGallery ? "focused" : false,
            waitForTransition: isProductPageGallery,
            dragMinThreshold: { mouse: 0, touch: isProductPageGallery ? 5 : 10 },
            flickPower: isProductPageGallery ? 800 : 600,
            speed: isProductPageGallery ? 250 : 400,
            padding: {
              right: !isProductPageGallery && gallery.dataset.showThumbsMobile === "false" ? "4rem" : 0,
            },
          },
          992: {
            destroy: isProductPageGallery,
            padding: 0,
            keyboard: false,
            waitForTransition: false,
            dragMinThreshold: { mouse: 0, touch: 10 },
            flickPower: 600,
            speed: 400,
          },
        },
        direction: document.documentElement.getAttribute("dir"),
      });

      const gallerySlides = Array.from(gallery.querySelectorAll(
        ".main-splide .splide__slide"
      ));
      const totalSlides = gallerySlides.length;

      const progress = gallery.querySelector(".pa-product-gallery-progress span");
      if (isProductPageGallery && totalSlides) {
        const updateGalleryState = (index = main.index) => {
          const safeIndex = Number.isFinite(index) ? index : 0;
          const currentIndex = ((safeIndex % totalSlides) + totalSlides) % totalSlides;
          const ratio = Number(gallerySlides[currentIndex].style.getPropertyValue("--pa-media-aspect-ratio"));
          gallery.style.setProperty("--pa-gallery-aspect-ratio", Number.isFinite(ratio) && ratio > 0 ? ratio : 1);
          if (progress) {
            progress.style.transform = `translateX(${currentIndex * 100}%)`;
          }
          if (window.matchMedia("(max-width: 991.98px)").matches) {
            [-1, 0, 1].forEach((offset) => {
              const slide = gallerySlides[(currentIndex + offset + totalSlides) % totalSlides];
              const image = slide.querySelector("img");
              if (image) image.loading = "eager";
            });
          }
        };
        main.on("mounted", () => updateGalleryState());
        main.on("move", updateGalleryState);
        main.on("moved", () => updateGalleryState());
      }

      const thumbs = new Splide(gallery.querySelector(".thumbs-splide"), {
        start: Number(gallery.dataset.start),
        arrows: Number(gallery.dataset.mediaCount > 3),
        gap: ".5rem",
        rewind: true,
        rewindByDrag: true,
        pagination: false,
        isNavigation: true,
        focus: totalSlides > 5 ? "center" : 0,
        mediaQuery: "min",
        breakpoints: {
          0: { perPage: 5, destroy: false },
          576: { perPage: 5 },
          768: { perPage: 5 },
          992: { perPage: 5, destroy: isProductPageGallery },
          1200: { perPage: 5 },
          1400: { perPage: 5 },
        },
        direction: document.documentElement.getAttribute("dir"),
      });

      main.on("move", (newIndex, prevIndex) => {
        const iframe = gallery.querySelector(
          `.splide__slide:nth-child(${prevIndex + 1}) iframe`
        );
        const video = gallery.querySelector(
          `.splide__slide:nth-child(${prevIndex + 1}) video`
        );
        if (iframe) {
          // eslint-disable-next-line no-self-assign
          iframe.src = iframe.src;
        }
        if (video) {
          video.pause();
        }
      });

      window.addEventListener(
        "variantChange.shopiweb.product",
        (event) => {
          const variantSelected = event.detail;

          if (variantSelected.featured_media && !(isProductPageGallery && window.matchMedia("(min-width: 992px)").matches)) {
            main.go(variantSelected.featured_media.position - 1);
          }
        },
        false
      );

      main.sync(thumbs);
      main.mount();
      thumbs.mount();

      if (!isProductPageGallery && window.matchMedia("(min-width: 992px)").matches) {
        const navbarHeight =
          document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight ||
          0;
        const announcementBarHeight =
          document.querySelector('[id*="__announcement-bar"].sticky-top')
            ?.clientHeight || 0;

        const galleryWrapper = gallery.closest(".product-gallery-wrapper");
        if (!galleryWrapper) return;
        galleryWrapper.style.position = "sticky";
        galleryWrapper.style.top = `${
          navbarHeight + announcementBarHeight + 20
        }px`;
        galleryWrapper.style.zIndex = "1";
      }

      if (window.GLightbox) {
        // eslint-disable-next-line no-unused-vars
        const lightbox = GLightbox({
          selector: `[data-gallery="product-gallery-${gallery.dataset.productId}"]`,
          videosWidth: "1290px",
          loop: true,
        });
        lightbox.on("open", () => {
          gallery.querySelectorAll("video").forEach((video) => {
            video.pause();
          });
        });
        lightbox.on("slide_changed", ({ prev, current }) => {
          if (!(isProductPageGallery && window.matchMedia("(min-width: 992px)").matches)) main.go(current.index);
        });
      }

      const modelViewer = gallery.querySelector("model-viewer");

      if (modelViewer) {
        const increaseBtn = gallery.querySelector(
          "[data-model-3d-increase-zoom]"
        );
        const decreaseBtn = gallery.querySelector(
          "[data-model-3d-decrease-zoom]"
        );
        const fullscreenBtn = gallery.querySelector(
          "[data-model-3d-fullscreen]"
        );

        increaseBtn.addEventListener("click", () => {
          modelViewer.zoom(1);
        });

        decreaseBtn.addEventListener("click", () => {
          modelViewer.zoom(-1);
        });

        fullscreenBtn.addEventListener("click", () => {
          if (document.fullscreenElement) {
            document.exitFullscreen();
            fullscreenBtn
              .querySelector(".bi-fullscreen")
              .removeAttribute("hidden");
            fullscreenBtn
              .querySelector(".bi-fullscreen-exit")
              .setAttribute("hidden", "hidden");
          } else {
            modelViewer
              .closest(".product-gallery-model-3d")
              .requestFullscreen();
            fullscreenBtn
              .querySelector(".bi-fullscreen")
              .setAttribute("hidden", "hidden");
            fullscreenBtn
              .querySelector(".bi-fullscreen-exit")
              .removeAttribute("hidden");
          }
        });
      }
    });
};
initializeProductGallery();

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector(".product-gallery")) {
    initializeProductGallery();
  }
});

window.addEventListener(
  "updated.shopiweb.collection",
  initializeProductGallery
);

/* =====================
   Barre d'inventaire
   ===================== */
const initializeInventoryBar = () => {
  const wrapper = document.querySelector("#inventory-bar");

  if (!wrapper) return;

  const progressBar = wrapper.querySelector(".progress-bar");

  setTimeout(() => {
    progressBar.style.width = progressBar.dataset.width;
  }, 250);
};
initializeInventoryBar();

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector("#inventory-bar")) {
    initializeInventoryBar();
  }
});

/* =====================
   Upsell modal
   ===================== */
const initializeUpsellModal = () => {
  const modal = document.querySelector("#modal-upsell-product");
  if (!modal) return;

  const form = document.querySelector(
    '#product-content form[onsubmit*="handleAddToCartFormSubmit"]'
  );
  if (!form) return;

  form.setAttribute("data-shopiweb-upsell-modal", "true");

  form.addEventListener("added.shopiweb.cart", () => {
    const modal = bootstrap.Modal.getOrCreateInstance("#modal-upsell-product");
    modal.show();
  });

  document.querySelectorAll("#modal-upsell-product .btn-atc").forEach((btn) => {
    btn.addEventListener("click", () => {
      const footerBtn = document.querySelector(
        "#modal-upsell-product .modal-footer .btn"
      );
      footerBtn.classList.remove(footerBtn.dataset.defaultClass);
      footerBtn.classList.add(footerBtn.dataset.activeClass);
    });
  });

  modal.addEventListener("hidden.bs.modal", () => {
    if (document.querySelector("#offcanvas-cart")) {
      const offcanvasCart =
        bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart");
      offcanvasCart.show();
    }
  });
};
initializeUpsellModal();

document.addEventListener("shopify:section:load", (e) => {
  if (e.target.querySelector("#modal-upsell-product")) {
    initializeUpsellModal();
  }
});

/* =====================
   Achetés ensemble
   ===================== */
const initializeBoughtTogether = () => {
  if (!document.querySelector("#bought-product-together")) return;

  const setTotalPrice = () => {
    let totalCompareAtPrice = 0;
    let totalPrice = 0;

    document
      .querySelectorAll("#bought-product-together .product-item-price")
      .forEach((elem) => {
        if (
          elem
            .closest(".product-item")
            .querySelector(".check-bought-together:checked")
        ) {
          const cmp = Number(elem.dataset.compareAtPrice || 0);
          const pr  = Number(elem.dataset.price || 0);
          totalCompareAtPrice += cmp && cmp > pr ? cmp : pr;
          totalPrice += pr;
        }
      });

    const totalElem = document.querySelector("#bought-together-total");

    if (totalCompareAtPrice > totalPrice) {
      totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}:
                <span class="bought-together-total-price text-success me-2">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoneyNoDecimals(totalPrice)}
                </span>
                <span class="bought-together-total-compare-price text-muted">
                    <span class="visually-hidden">
                        ${window.theme.product.priceRegular} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoneyNoDecimals(totalCompareAtPrice)}
                    </s>
                </span>
            `;
    } else {
      totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}:
                <span class="bought-together-total-price">
                    ${Shopify.formatMoneyNoDecimals(totalPrice)}
                </span>
            `;
    }
  };

  document.querySelectorAll(".check-bought-together").forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        checkbox.closest(".product-item").style.opacity = "1";
      } else {
        checkbox.closest(".product-item").style.opacity = ".5";
      }

      if (document.querySelector(".check-bought-together:checked")) {
        document.querySelector("#add-to-cart-bought-together").disabled = false;
      } else {
        document.querySelector("#add-to-cart-bought-together").disabled = true;
      }

      setTotalPrice();
    });
  });

  document
    .querySelectorAll('#bought-product-together select[name="id"]')
    .forEach((select) => {
      select.addEventListener("change", () => {
        const compareAtPrice =
          select.options[select.selectedIndex].dataset.compareAtPrice || "0";
        const price = select.options[select.selectedIndex].dataset.price || "0";

        select
          .closest(".product-item")
          .querySelector(".product-item-price")
          .setAttribute("data-compare-at-price", compareAtPrice);
        select
          .closest(".product-item")
          .querySelector(".product-item-price")
          .setAttribute("data-price", price);

        setTotalPrice();
      });
    });

  document
    .querySelector("#add-to-cart-bought-together")
    .addEventListener("click", async (e) => {
      const btn = e.target;

      btn.style.width = btn.clientWidth + 4 + "px";
      btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;

      const items = [];

      document
        .querySelectorAll("#bought-product-together .product-item")
        .forEach((elem) => {
          if (elem.querySelector(".check-bought-together:checked")) {
            items.push({
              id: Number(elem.querySelector('[name="id"]').value),
              quantity: 1,
            });
          }
        });

      const response = await fetch(window.themeRoute("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      btn.innerHTML = window.theme.product.addedToCart;

      setTimeout(() => {
        btn.innerHTML = btn.dataset.textAddToCart;
      }, 2000);

      window.updateCartContents(response);

      bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
    });
};
initializeBoughtTogether();

/* =====================
   Produits précédents/suivants (ne s'affiche que si le produit fait partie d'une collection)
   ===================== */
const inititializeButtonsPrevNext = async () => {
  const wrapper = document.querySelector("#product-prev-next");

  if (!wrapper) return;

  if (!window.matchMedia("(max-width: 1599px)").matches) return;

  await new Promise((resolve) => setTimeout(resolve, 1000));

  const threshold =
    document
      .querySelector('.product-content form[action*="/cart/add"]')
      .getBoundingClientRect().bottom + window.scrollY;

  window.addEventListener("scroll", () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add("show");
    } else {
      wrapper.classList.remove("show");
    }
  });
};
inititializeButtonsPrevNext();

/* =====================
   Pack quantité (Qty Breaks)
   ===================== */
const initializeQantityBreaks = () => {
  document.querySelectorAll('[name="product-qty-breaks"]').forEach((radio) => {
    radio.addEventListener("change", () => {
      const qty = Number(radio.dataset.qty);

      const qtyField = radio.closest("form").querySelector('[name="quantity"]');
      const form = radio.closest("form");
      const btn = form.querySelector('button[name="add"]');

      if (!qtyField) return;

      qtyField.value = qty;
      qtyField.dispatchEvent(new Event("change"));

      setTimeout(() => {
        btn.classList.add("animate__animated", "animate__shakeX");
      }, 250);

      setTimeout(() => {
        btn.classList.remove("animate__animated", "animate__shakeX");
      }, 1500);
    });
  });
};
initializeQantityBreaks();

/* =====================
   Personnalisation (propriétés personnalisées)
   ===================== */
const initializePersonalization = () => {
  document
    .querySelectorAll('.product-personalization-field[data-type="checkbox"]')
    .forEach((elem) => {
      let values = [];

      elem.querySelectorAll("input").forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          if (checkbox.checked) {
            values.push(checkbox.value);
          } else {
            values = values.filter((item) => item !== checkbox.value);
          }

          elem.querySelector('[type="hidden"]').value = values.join(", ");
        });
      });
    });
};
initializePersonalization();

/* =====================
   Synchroniser la quantité entre la fiche produit, Sticky ATC, etc.
   ===================== */
const initializeSyncQty = () => {
  const productFormQtyInput = document.querySelector(
    '.product-buy-buttons input[name="quantity"]'
  );

  if (!productFormQtyInput) return;

  productFormQtyInput.addEventListener("change", () => {
    const stickyAtcQtyInput = document.querySelector(
      '#sticky-atc input[name="quantity"]'
    );

    if (!stickyAtcQtyInput) return;

    stickyAtcQtyInput.value = productFormQtyInput.value;
  });
};
initializeSyncQty();

const initializeProductInformationSticky = () => {
  const column = document.querySelector('#product-template .product-information-column');
  if (!column) return;
  column.paStickyCleanup?.();
  const desktop = window.matchMedia('(min-width: 992px)');
  const headers = [...document.querySelectorAll('.shopify-section[id*="__navbar"], .shopify-section[id*="__announcement-bar"]')];
  let frame = 0;
  const update = () => {
    frame = 0;
    if (!desktop.matches) {
      column.style.removeProperty('--pa-product-info-top');
      return;
    }
    const headerBottom = headers.reduce((bottom, header) => {
      const style = getComputedStyle(header);
      if (style.position !== 'sticky' && style.position !== 'fixed') return bottom;
      return Math.max(bottom, (parseFloat(style.top) || 0) + header.getBoundingClientRect().height);
    }, 0);
    const top = Math.min(headerBottom + 12, window.innerHeight - column.getBoundingClientRect().height - 24);
    column.style.setProperty('--pa-product-info-top', `${Math.round(top)}px`);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const observer = new ResizeObserver(schedule);
  [column, ...headers].forEach(element => observer.observe(element));
  window.addEventListener('resize', schedule, { passive: true });
  desktop.addEventListener('change', schedule);
  column.paStickyCleanup = () => {
    observer.disconnect();
    window.removeEventListener('resize', schedule);
    desktop.removeEventListener('change', schedule);
    cancelAnimationFrame(frame);
  };
  update();
};
initializeProductInformationSticky();
document.addEventListener('shopify:section:load', initializeProductInformationSticky);
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelector('.product-information-column')?.paStickyCleanup?.();
});

/* =====================
   Offre limitée, Visiteurs en direct, Livraison estimée
   ===================== */
const initializeLimitedOffer = () => {
  const blocks = document.querySelectorAll(
    "#product-limited-offer, #product-live-visitors, #product-estimated-delivery"
  );

  if (!blocks.length) return;

  blocks.forEach((block) => {
    const icon = block.querySelector(".block-icon");

    setInterval(() => {
      icon.classList.add("animate__animated", "animate__tada");

      setTimeout(() => {
        icon.classList.remove("animate__animated", "animate__tada");
      }, 1500);
    }, 3000);
  });
};

initializeLimitedOffer();

/* =====================
   Bloc produit Témoignages
   ===================== */
//Injecté dans product-block-testimonials.liquid







